<template>
  <div class="circle-docs container mt-1 bg-white" v-if="isMember || isAdmin">
    <div class="d-flex justify-content-between py-3">
      <span class="fs-20 fw-700">{{ $t('home_page.lbl_org_resource') }}</span>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="goToDetail"
        class="cursor-pointer"
      >
        <path
          d="M6 18.4998L17.9998 6.5"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.9998 18.4998L6 6.5"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="d-flex mb-3" v-if="circle">
      <a
        href="javascript:;"
        class="fs-16 fw-600 txt-grey-900 mr-2"
        @click="goToFolder(null)"
      >{{ circle && circle.name }} ></a>
      <div v-if="bread && bread.length">
        <a
          href="javascript:;"
          class="fs-16 fw-600 mr-2"
          v-for="(b, i) in bread"
          :key="b.id + 'b'"
          :class="i === bread.length - 1 ? 'txt-grey-600' : 'txt-grey-900'"
          @click="goToFolder(b.id)"
        >{{ b.name }} ></a>
      </div>
    </div>

    <!-- Upload file -->
    <div class="mb-3">
      <div class="mb-0 fs-14 fw-600 u-button">
        <div
          class="cursor-pointer mr-5 txt-pri fw-600 fs-14 d-flex align-items-center"
          @click="modalUpFolder(true)"
        >
          <img class="mr-1" src="../../../public/assets/images/icon/u_folder.svg" />
          {{ $t('circle_feature.btn_create_folder') }}
        </div>
        <div
          class="cursor-pointer mr-5 txt-pri fw-600 fs-14 d-flex align-items-center"
          @click="modalUpload(true)"
        >
          <img class="mr-1" src="../../../public/assets/images/icon/u_upload.svg" />
          {{ $t('circle_feature.btn_upload_file') }}
        </div>
        <div
          class="cursor-pointer mr-5 txt-pri fw-600 fs-14 d-flex align-items-center"
          @click="openModalUploadPacs(true)"
        >
          <img class="mr-1" src="../../../public/assets/images/icon/u_upload.svg" />
          {{ $t('circle_feature.btn_upload_pacs') }}
        </div>
        <div
          class="cursor-pointer txt-pri fw-600 fs-14 d-flex align-items-center"
          @click="modalLink(true)"
        >
          <svg
            class="mr-1"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.33352 14.6252L6.85852 16.0586C6.47175 16.4453 5.94717 16.6626 5.40019 16.6626C4.85321 16.6626 4.32863 16.4453 3.94186 16.0586C3.55508 15.6718 3.33779 15.1472 3.33779 14.6002C3.33779 14.0533 3.55508 13.5287 3.94186 13.1419L7.72519 9.35024C8.09653 8.97769 8.59687 8.76214 9.1227 8.74818C9.64853 8.73422 10.1596 8.92292 10.5502 9.27524L10.6502 9.35857C10.8082 9.51328 11.0212 9.59888 11.2424 9.59654C11.4635 9.59419 11.6746 9.5041 11.8294 9.34607C11.9841 9.18805 12.0697 8.97504 12.0673 8.7539C12.065 8.53277 11.9749 8.32162 11.8169 8.16691C11.7698 8.1061 11.7198 8.04769 11.6669 7.99191C10.9555 7.373 10.0355 7.04761 9.09316 7.08165C8.15086 7.11569 7.25672 7.50662 6.59186 8.17524L2.75852 11.9669C2.10715 12.6759 1.75487 13.6091 1.77525 14.5717C1.79563 15.5343 2.18709 16.4518 2.86788 17.1325C3.54868 17.8133 4.46616 18.2048 5.42873 18.2252C6.3913 18.2456 7.32453 17.8933 8.03352 17.2419L9.47519 15.8336C9.61754 15.6783 9.69579 15.4748 9.6942 15.2642C9.69261 15.0535 9.61129 14.8513 9.46661 14.6982C9.32194 14.545 9.12464 14.4524 8.91441 14.4389C8.70418 14.4253 8.49663 14.4919 8.33352 14.6252ZM17.2419 2.75857C16.5408 2.06191 15.5927 1.6709 14.6044 1.6709C13.616 1.6709 12.6679 2.06191 11.9669 2.75857L10.5252 4.16691C10.3828 4.3222 10.3046 4.52564 10.3062 4.7363C10.3078 4.94695 10.3891 5.14919 10.5338 5.30231C10.6784 5.45544 10.8757 5.54809 11.086 5.56162C11.2962 5.57515 11.5037 5.50856 11.6669 5.37524L13.1085 3.94191C13.4953 3.55513 14.0199 3.33785 14.5669 3.33785C15.1138 3.33785 15.6384 3.55513 16.0252 3.94191C16.412 4.32868 16.6292 4.85326 16.6292 5.40024C16.6292 5.94722 16.412 6.4718 16.0252 6.85857L12.2419 10.6502C11.8705 11.0228 11.3702 11.2383 10.8443 11.2523C10.3185 11.2663 9.80744 11.0776 9.41686 10.7252L9.31686 10.6419C9.15883 10.4872 8.94582 10.4016 8.72468 10.4039C8.50355 10.4063 8.2924 10.4964 8.13769 10.6544C7.98298 10.8124 7.89738 11.0254 7.89972 11.2466C7.90207 11.4677 7.99216 11.6789 8.15019 11.8336C8.21072 11.8955 8.27471 11.9539 8.34186 12.0086C9.05409 12.6256 9.97371 12.9498 10.9154 12.9158C11.8572 12.8817 12.751 12.4921 13.4169 11.8252L17.2085 8.03358C17.9096 7.33697 18.3066 6.39127 18.3129 5.40295C18.3191 4.41463 17.9341 3.46398 17.2419 2.75857Z"
              fill="#20409B"
            />
          </svg>
          {{ $t('circle_feature.btn_add_link') }}
        </div>
      </div>
    </div>

    <!-- Search & filter -->
    <div class="flex justify-between mb-4 items-center">
      <div class="flex items-center mt-3 w-72">
        <div class="input-group input-search-box input-search mb-1">
          <input
            type="search"
            v-model="search"
            class="form-control bg-white"
            :placeholder="$t('circle_feature.lbl_enter_doctor_msg')"
            @keyup.enter="getCircleAttachments"
          />
          <span
            class="input-group-text bg-white border-0 radius-10 font-size-20 cursor-pointer"
            @click="getCircleAttachments"
          >
            <i class="fa fa-search"></i>
          </span>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <div class="fs-14 font-bold text-gray-900">
          <span class="mb-2">{{ $t("lbl_select_type") }}</span>
          <el-select v-model="filter.documentType" class="w-full">
            <div v-for="item in DOCUMENT_OPTIONS" :key="item.type + 'dc'">
              <el-option
                v-if="!(item.type === DOCUMENT_OPTIONS[0].type && $route.params.folder === 'meet')"
                :label="$t(`${item.label}`)"
                :value="item.type"
              />
            </div>
          </el-select>
        </div>
        <div>
          <label class="fs-14 font-bold text-gray-900 mb-0">
            <span class="mb-2">{{ $t("lbl_from_date") }}</span>
            <span class="hodo-el block el-input el-input--suffix">
              <input
                name="fromDate"
                v-model="filter.fromDate"
                type="date"
                class="el-input__inner pr-3 bg-white border border-gray-200"
                :placeholder="$t('lbl_select_date')"
              />
            </span>
          </label>
        </div>
        <div>
          <label class="fs-14 font-bold text-gray-900 mb-0">
            <span class="mb-2">{{ $t("lbl_to_date") }}</span>
            <span class="hodo-el block el-input el-input--suffix">
              <input
                name="toDate"
                v-model="filter.toDate"
                type="date"
                class="el-input__inner pr-3 bg-white border border-gray-200"
                :placeholder="$t('lbl_select_date')"
              />
            </span>
          </label>
        </div>
      </div>
    </div>
    <!-- Table -->
    <div class="row">
      <div class="row pr-0 py-0 pl-3 fs-16 fw-600">
        <div class="flex items-center py-2 border-bottom">
          <div class="col-4">{{ $t('lbl_name') }}</div>
          <div class="col-3">{{ $t('lbl_created_user') }}</div>
          <div class="col-2">{{ $t('lbl_created_date') }}</div>
          <div class="col-1">{{ $t('lbl_type') }}</div>
          <div class="col-2"></div>
        </div>
      </div>
      <div class="px-3">
        <div
          class="row flex items-center p-2 item-doc"
          v-for="(item,index) in attachments"
          :key="index + 'item'"
        >
          <div
            @click="openDocAttach(item)"
            class="col-4 flex items-center gap-1 p-0"
            :set="(icon = getFileAttIcon(item))"
          >
            <div
              class="item-doc-thumb-img flex justify-center items-center"
              v-if="icon && icon.is_image"
            >
              <img
                width="30"
                height="30"
                src="../../../public/assets/images/icon/image_default.svg"
                alt
              />
            </div>
            <div
              class="item-doc-thumb-img d-flex justify-center items-center"
              v-if="icon && !icon.is_image"
            >
              <img width="24" height="24" :src="icon.path" alt />
            </div>
            <p
              class="flex-1 block px-2 txt-black fs-14 fw-500 break-all mb-0"
            >{{ item.isFile ? item.file.name:item.folder.name }}</p>
          </div>
          <p
            @click="openDocAttach(item)"
            class="col-3 p-0 fs-14 txt-black fw-500 max-line-1 mb-0"
          >{{ getCreateBy(item) }}</p>
          <p @click="openDocAttach(item)" class="col-2 p-0 fs-14 txt-black fw-500 max-line-1 mb-0">
            {{ item.last_update ? DDMMYYYYSlash(item.last_update) : item.created_at
            ? DDMMYYYYSlash(item.created_at) : '' }}
          </p>
          <p
            @click="openDocAttach(item)"
            class="col-1 p-0 capitalize txt-black fs-14 fw-500 max-line-1 mb-0"
          >{{ getDocType(item) }}</p>
          <div @click="openDocAttach(item)" class="col-1 p-0 text-center flex gap-2">
            <p
              class="fs-14 max-line-1 mb-0"
              v-if="item.isFile && item.file.type == 3 && item.file.pac"
              :set="pacStatus = getPacStatus(item.file.pac.status)"
            >
              <span
                class="text-center"
                :class="pacStatus ? pacStatus.class : ''"
              >{{ pacStatus.name || '' }}</span>
            </p>

            <div
              class="p-0 radius-10 c-pointer"
              v-if="item.isFile && item.file.type == 3 && item.file.pac && item.file.pac.status === 2"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.25 9.14993C18.94 5.51993 15.56 3.42993 12 3.42993C10.22 3.42993 8.49 3.94993 6.91 4.91993C5.33 5.89993 3.91 7.32993 2.75 9.14993C1.75 10.7199 1.75 13.2699 2.75 14.8399C5.06 18.4799 8.44 20.5599 12 20.5599C13.78 20.5599 15.51 20.0399 17.09 19.0699C18.67 18.0899 20.09 16.6599 21.25 14.8399C22.25 13.2799 22.25 10.7199 21.25 9.14993ZM12 16.0399C9.76 16.0399 7.96 14.2299 7.96 11.9999C7.96 9.76993 9.76 7.95993 12 7.95993C14.24 7.95993 16.04 9.76993 16.04 11.9999C16.04 14.2299 14.24 16.0399 12 16.0399Z"
                  fill="#476DD6"
                />
                <path
                  d="M12.0004 9.13989C10.4304 9.13989 9.15039 10.4199 9.15039 11.9999C9.15039 13.5699 10.4304 14.8499 12.0004 14.8499C13.5704 14.8499 14.8604 13.5699 14.8604 11.9999C14.8604 10.4299 13.5704 9.13989 12.0004 9.13989Z"
                  fill="#476DD6"
                />
              </svg>
            </div>
          </div>

          <div class="col-1 p-0 text-right" v-if="checkRole(item)">
            <div class="dropdown">
              <img
                src="../../../public/assets/images/icon/icon-more.svg"
                class="dropdown-toggle"
                data-toggle="dropdown"
              />
              <div
                class="dropdown-menu item-drop z-10 relative"
                aria-labelledby="dropdownMenuButton"
              >
                <a
                  class="dropdown-item fs-16"
                  href="javascript:;"
                  @click="modalEdit(true, item)"
                  v-if="(item.isFile && Number(item.file.type) === 2)"
                >
                  <img class="mr-2" src="../../../public/assets/images/icon/icon-edit-2.svg" />
                  {{ $t('circle_feature.lbl_change_name') }}
                </a>

                <a
                  class="dropdown-item fs-16"
                  href="javascript:;"
                  @click="modalEditFolder(true, item)"
                  v-if="item.isFile === 0"
                >
                  <img class="mr-2" src="../../../public/assets/images/icon/icon-edit-2.svg" />
                  {{ $t('circle_feature.lbl_change_name') }}
                </a>

                <a
                  class="dropdown-item fs-16"
                  href="javascript:;"
                  v-if="item.isFile"
                  @click="deleteCircleAttachment(item.file.id)"
                >
                  <img class="mr-3" src="../../../public/assets/images/icon/icon-trash-2.svg" />
                  {{
                  $t('multidisciplinary_board.btn_remove') }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <AppPagination
          :paginationProps="pagination"
          @onChangePagination="(data) => handleChangePagination(data)"
        />
        <!-- </div> -->
      </div>
      <!-- Table -->

      <!-- Modal Upload folder -->
      <div
        class="modal fade"
        id="modalUpFolder"
        tabindex="-1"
        aria-labelledby="modalUploadTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-sm modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header border-0 bg-white mt-3 mb-0">
              <h5 class="ml-4 fs-18 fw-700 txt-black">{{ $t('circle_feature.btn_add_folder') }}</h5>
              <img
                src="../../../public/assets/images/icon/close-gray.svg"
                height="25px"
                class="cursor-pointer mr-3 mb-2"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="name" class="txt-greyscale-600 fs-16 fw-600 mb-2 required">
                  {{
                  $t('circle_feature.lbl_folder_name') }}
                </label>
                <input
                  v-model="formFolder.name"
                  type="text"
                  class="form-control form-input border-custom bg-white"
                />
              </div>
            </div>
            <div class="modal-footer border-0 justify-content-center mb-2">
              <button
                type="button"
                class="btn bg-pri bd-pri text-white upload-btn2 radius-10 w-100"
                @click="onSubmitAddFolder"
              >{{ $t('circle_feature.lbl_add') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Upload file -->
    <div
      class="modal fade"
      id="modalUpload"
      tabindex="-1"
      aria-labelledby="modalUploadTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 bg-white mt-3 mb-0">
            <h5 class="ml-4 fs-18 fw-700 txt-black">{{ $t('circle_feature.lbl_select_file') }}</h5>
            <img
              src="../../../public/assets/images/icon/close-gray.svg"
              height="25px"
              class="cursor-pointer mr-3 mb-2"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body">
            <div class="upload-btn mb-3" @click="openInputDoc">
              <img class="mr-1" src="../../../public/assets/images/icon/u_upload.svg" />
              <span class="fs-14 txt-pri">{{ $t('circle_feature.lbl_select_file') }}</span>
            </div>
            <div class="mb-3" v-for="(doc, i) in selected_docs" :key="i + 'slt_file'">
              <div class="d-flex w-100 justify-content-between align-items-center">
                <div class="d-flex align-items-center" :set="(icon = getFileIcon(doc))">
                  <div class="mr-2 selected-file-icon" :style="`background-image: url('${icon}');`"></div>
                  <p class="fs-14 fw-600 mb-0 max-line-1 w-265px">{{ doc.name }}</p>
                </div>
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="cursor-pointer"
                  @click="deleteSltDoct(i)"
                >
                  <path
                    d="M6.00012 18.4998L17.9999 6.5"
                    stroke="#292D32"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.9999 18.4998L6.00012 6.5"
                    stroke="#292D32"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center mb-2">
            <button
              type="button"
              class="btn bg-pri bd-pri text-white upload-btn2 radius-10 w-100"
              @click="onUpload"
              :disabled="uploading || !selected_docs || !selected_docs.length"
            >
              <span class="spinner-border mr-2" role="status" v-if="uploading">
                <span class="sr-only">Loading...</span>
              </span>
              {{ uploading ? this.$t('circle_feature.lbl_uploading') :
              this.$t('circle_feature.lbl_upload') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <input
      type="file"
      ref="inputFile"
      accept="*"
      @change="onSelectDoc($event)"
      multiple
      class="d-none"
    />

    <!-- //link -->
    <div
      class="modal fade"
      id="modalLink"
      tabindex="-1"
      aria-labelledby="modalLinkTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 bg-white mt-3 mb-0">
            <h5 class="ml-4 fs-18 fw-700 txt-black">{{ $t('circle_feature.btn_add_link') }}</h5>
            <img
              src="../../../public/assets/images/icon/close-gray.svg"
              height="25px"
              class="cursor-pointer mr-3 mb-2"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="name" class="txt-greyscale-600 fs-16 fw-600 mb-2 required">Link</label>
              <input
                v-model="form.link"
                type="text"
                class="form-control form-input border-custom bg-white mb-3"
              />
              <label for="name" class="txt-greyscale-600 fs-16 fw-600 mb-2">
                {{
                $t('circle_feature.lbl_description')
                }}
              </label>
              <input
                v-model="form.name"
                type="text"
                class="form-control form-input border-custom bg-white"
              />
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center mb-2">
            <button
              type="button"
              class="btn bg-pri bd-pri text-white upload-btn2 radius-10 w-100"
              @click="onSubmitLink"
            >{{ $t('circle_feature.lbl_update') }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- //edit Link -->
    <div
      class="modal fade"
      id="modalEdit"
      tabindex="-1"
      aria-labelledby="modalEditTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 bg-white mt-3 mb-0">
            <h5 class="ml-4 fs-18 fw-700 txt-black">{{ $t('circle_feature.lbl_change_name') }}</h5>
            <img
              src="../../../public/assets/images/icon/close-gray.svg"
              height="25px"
              class="cursor-pointer mr-3 mb-2"
              data-dismiss="modal"
              aria-label="Close"
              ref="Close"
            />
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="name" class="txt-greyscale-600 fs-16 fw-600 mb-2 required">Link</label>
              <input
                v-model="form.link"
                type="text"
                class="form-control form-input border-custom bg-white mb-3"
              />
              <label for="name" class="txt-greyscale-600 fs-16 fw-600 mb-2">
                {{
                $t('circle_feature.lbl_description')
                }}
              </label>
              <input
                v-model="form.name"
                type="text"
                class="form-control form-input border-custom bg-white"
              />
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center mb-2">
            <button
              type="button"
              class="btn bg-pri bd-pri text-white upload-btn2 radius-10 w-100"
              @click="updateCircleAttachment"
            >
              <!-- <span class="spinner-border mr-2" role="status">
                  <span class="sr-only">Loading...</span>
              </span>-->
              {{ $t('circle_feature.lbl_update') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <ModalUploadPacs @onUploadPac="onUploadPac" />

    <!-- //edit Folder -->
    <div
      class="modal fade"
      id="modalEditFolder"
      tabindex="-1"
      aria-labelledby="modalEditTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 bg-white mt-3 mb-0">
            <h5 class="ml-4 fs-18 fw-700 txt-black">{{ $t('circle_feature.lbl_change_name') }}</h5>
            <img
              src="../../../public/assets/images/icon/close-gray.svg"
              height="25px"
              class="cursor-pointer mr-3 mb-2"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="name" class="txt-greyscale-600 fs-16 fw-600 mb-2 required">
                {{
                $t('circle_feature.lbl_name')
                }}
              </label>
              <input
                v-model="formFolder.name"
                type="text"
                class="form-control form-input border-custom bg-white"
              />
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center mb-2">
            <button
              type="button"
              class="btn bg-pri bd-pri text-white upload-btn2 radius-10 w-100"
              @click="updateCircleFolder"
            >
              <!-- <span class="spinner-border mr-2" role="status">
                  <span class="sr-only">Loading...</span>
              </span>-->
              {{ $t('circle_feature.lbl_update') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import appUtils from '../../utils/appUtils'
import uploadCircleFile from '../../utils/uploadCircleFile'
import ModalUploadPacs from '../../components/Files/ModalUploadPacs.vue'
import moment from 'moment'
import { AppPagination } from '@/components/Common'

const file_icons = [
  { type: ['doc', 'docx', 'docm'], path: 'assets/images/icon/icon-doc.svg' },
  {
    type: ['pptx', 'ppsx', 'ppt', 'pptm'],
    path: 'assets/images/icon/icon-pptx.svg'
  },
  {
    type: ['xlsx', 'xlsm', 'xlsb', 'xltx'],
    path: 'assets/images/icon/icon-xls.svg'
  },
  { type: ['pdf'], path: 'assets/images/icon/icon-pdf.svg' },
  { type: ['zip', 'rar', '7z'], path: 'assets/images/icon/icon-file.svg' },
  { type: ['link'], path: 'assets/images/icon/u_link.svg' },
  { type: ['folder'], path: 'assets/images/icon/_folder.svg' },
  { type: ['pac'], path: 'assets/images/icon/pac-icon.png' },
  { type: ['undefine'], path: 'assets/images/icon/undefine.svg' },
  {
    type: ['mp3', 'flac', 'aac', 'alac', 'wma', 'ogg', 'wav', 'aiff'],
    path: 'assets/images/icon/audio.svg'
  },
  {
    type: [
      'webm',
      'mkv',
      'flv',
      'flv',
      'vob',
      'ogv',
      'gifv',
      'mng',
      'avi',
      'mov',
      'wmv',
      'yuv',
      'rm',
      'rmvb',
      'mp4',
      '3gp',
      'm4v',
      'mpg'
    ],
    path: 'assets/images/icon/icon-video-f.svg'
  }
]
const pac_statuses = [
  { id: 1, name: 'Đang xử lý', class: 'text-warning' },
  { id: 2, name: 'Hoàn thành', class: 'text-success' },
  { id: 3, name: 'Không xử lý được tài liệu', class: 'text-danger' }
]

const DOCUMENT_OPTIONS = [
  {
    type: 1,
    label: 'lbl_all'
  },
  {
    type: 2,
    label: 'lbl_folder'
  },
  {
    type: 3,
    label: 'lbl_files'
  },
  {
    type: 4,
    label: 'PACS file'
  },
  {
    type: 5,
    label: 'Link'
  }
]

const FILE_TYPE = {
  file: 1,
  link: 2,
  pacs: 3,
  carePlan: 4
}

export default {
  name: 'CircleDocumentsV2',
  components: { ModalUploadPacs, AppPagination },
  data () {
    return {
      exts: [
        'jpeg',
        'png',
        'jpg',
        'gif',
        'svg',
        'doc',
        'docx',
        'pdf',
        'xls',
        'xlsx',
        'xlsm',
        'ppt',
        'pptx',
        'zip',
        'rar',
        '7z',
        'link'
      ],
      img_exts: ['jpeg', 'png', 'jpg', 'gif', 'svg', 'link'],
      file_icons,
      err_file: '',
      selected_docs: [],
      search: '',
      circle: null,
      attachments: [],
      uploading: false,
      circle_member: null,
      user_id: null,
      days: 10000,
      item_select: null,
      uploadCircleFile,
      folder: null,
      bread: [],
      pac_statuses,
      isFolder: false,
      formFolder: {
        name: '',
        parent_id: null
      },
      form: {
        name: '',
        link: ''
      },
      filter: {
        documentType: DOCUMENT_OPTIONS[0].type,
        fromDate: '',
        toDate: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 15,
        totalItems: 0
      },
      DOCUMENT_OPTIONS
    }
  },
  computed: {
    isMember () {
      return !!this.circle_member && this.circle_member.status === 2
    },
    isAdmin () {
      return (
        (!!this.isMember && this.circle_member.role === 1) ||
        this.circle?.created_by === this.user_id
      )
    }
  },
  mounted () {
    this.user_id = appUtils.getLocalUser()?.id
    this.prepare()
    if (this.$route.params.folder) {
      this.isFolder = true
    } else {
      this.isFolder = false
    }
  },
  watch: {
    '$route.params.id' () {
      this.prepare()
    },
    '$route.params.folder' () {
      if (Number(this.$route.params.folder) >= 0) {
        this.isFolder = true
        this.filter.documentType = DOCUMENT_OPTIONS[0].type
        this.showCircleFolder()
        this.getCircleAttachments()
      } else {
        this.filter.documentType = DOCUMENT_OPTIONS[0].type
        this.isFolder = false
        this.showCircleFolder()
        this.getCircleAttachments()
      }
    },
    $refresh () {
      this.showCircleFolder()
      this.getCircleAttachments()
    },
    filter: {
      handler: function (filterData) {
        this.getCircleAttachments()
      },

      deep: true
    }
  },
  methods: {
    goToDetail () {
      this.$router
        .push({ name: 'CircleDetail', params: { id: this.$route.params.id } })
        .catch(() => {})
    },
    goToFolder (folderId) {
      let params = {
        id: this.$route.params.id
      }
      if (folderId) {
        params.folder = folderId
        this.$router
          .push({ name: 'CircleDocumentsFolder', params: params })
          .catch(() => {})
      } else {
        this.$router
          .push({ name: 'CircleDocuments', params: params })
          .catch(() => {})
      }
    },
    async prepare () {
      try {
        this.loading = true
        let m = await this.getMember()
        let c = await this.showCircle()
        if (
          (m && m.data && m.data.status === 2) ||
          c?.data?.created_by === this.user_id
        ) {
          this.showCircleFolder()
          this.getCircleAttachments()
        } else {
          this.$toast.open({
            message: this.$t('circle_feature.lbl_permission_msg'),
            type: 'warning'
          })
          this.$router.push({ name: 'CircleList' })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getMember () {
      let self = this
      let r = await this.$rf
        .getRequest('DoctorRequest')
        .getMemberByUserId(
          this.$route.params.id,
          appUtils.getLocalUser().id,
          null,
          false
        )
        .then(r => {
          console.log(r.data)
          self.circle_member = r.data
          return r
        })
        .catch(() => {
          return false
        })
      return r
    },
    async showCircle () {
      if (!this.$route.params.id) return
      let self = this
      let r = await this.$rf
        .getRequest('DoctorRequest')
        .showCircle(this.$route.params.id)
        .then(r => {
          self.circle = r.data
          return r
        })
        .catch(e => {
          console.log(e)
          self.$toast.open({
            message: this.$t('circle_feature.lbl_permission_msg'),
            type: 'warning'
          })
          self.$router.push({ name: 'CircleList' })
          return false
        })
      return r
    },
    async showCircleFolder () {
      this.bread = []
      if (!this.$route.params.folder) {
        this.folder = null
        this.bread = []
        return
      }
      if (!this.$route.params.id) return
      let self = this
      let r = await this.$rf
        .getRequest('DoctorRequest')
        .showCircleFolder(this.$route.params.id, this.$route.params.folder)
        .then(r => {
          self.folder = r.data
          self.getBread(r.data, true)
          return r
        })
        .catch(e => {
          console.log(e)
          self.$toast.open({
            message: this.$t('circle_feature.lbl_folder_notexist'),
            type: 'warning'
          })
          self.goToDetail()
          return false
        })
      return r
    },
    async getCircleAttachments (data) {
      let self = this

      let params = {
        page: data?.currentPage || this.pagination.currentPage,
        limit: data?.pageSize || this.pagination.pageSize,
        folderId: this.$route.params.folder || 0,
        keyword: this.search
      }
      if (this.filter.documentType) {
        params.type = this.filter.documentType
      }
      if (this.filter.fromDate && this.filter.toDate) {
        params.startDate = moment(this.filter.fromDate).format('YYYY/MM/DD')
        params.endDate = moment(this.filter.endDate).format('YYYY/MM/DD')
      }

      await this.$rf
        .getRequest('DoctorRequest')
        .getCircleAttachmentsV2(this.$route.params.id, params)
        .then(r => {
          const responseData = r.data
          self.attachments = responseData.data
          self.pagination = {
            currentPage: responseData.meta?.current_page || 1,
            pageSize: Number(responseData?.meta.per_page) || 15,
            totalItems: responseData.meta?.total || 0
          }
        })
        .catch(() => {
          self.goToDetail()
        })
    },
    modalUpload (show) {
      window.$('#modalUpload').modal(show ? 'show' : 'hide')
    },
    modalUpFolder (show) {
      window.$('#modalUpFolder').modal(show ? 'show' : 'hide')
    },
    modalLink (show) {
      window.$('#modalLink').modal(show ? 'show' : 'hide')
    },
    openModalUploadPacs (show) {
      window.$('#modalUploadPac').modal(show ? 'show' : 'hide')
    },
    openInputDoc () {
      this.$refs.inputFile.click()
      this.$refs.inputFile.value = null
    },
    onSelectDoc (e) {
      const self = this
      const files = e.target.files
      self.err_file = ''
      let errFile = ''
      if (files) {
        for (let i = 0; i < files.length; i++) {
          const f = files[i]
          self.selected_docs.push(f)
        }
      }
      self.$refs.inputFile.value = null
      if (errFile) {
        alert(
          this.$t('circle_feature.lbl_file_no') +
            errFile.substring(0, errFile.length - 1) +
            this.$t('circle_feature.lbl_reject_format_msg')
        )
      }
    },
    validateFile (ext) {
      return this.exts.findIndex(e => e === ext.toLowerCase()) > -1
    },
    isImage (ext) {
      return this.img_exts.findIndex(e => e === ext.toLowerCase()) > -1
    },
    getBase64URL (file) {
      return URL.createObjectURL(file)
    },
    getImageUrl (path) {
      return appUtils.getDocumentURL(path)
    },
    getFileIcon (doc) {
      if (this.isImage(doc.name.split('.').pop())) {
        return this.getBase64URL(doc)
      } else {
        let extIc = this.file_icons.find(
          fi => fi.type.findIndex(t => t === doc.name.split('.').pop()) > -1
        )
        if (extIc) {
          return extIc.path
        } else {
          return this.file_icons[5].path
        }
      }
    },
    getFileAttIcon (doc) {
      if (doc?.isFile === 1) {
        if (Number(doc.file.type) === 3) {
          return { is_image: false, path: this.file_icons[7].path }
        } else if (Number(doc.file.type) === 2) {
          return { is_image: false, path: this.file_icons[5].path }
        } else {
          if (this.isImage(doc.file.name.split('.').pop())) {
            return { is_image: true, path: doc.url }
          } else {
            let extIc = this.file_icons.find(
              fi =>
                fi.type.findIndex(t => t === doc.file.name.split('.').pop()) >
                -1
            )
            if (extIc) {
              return { is_image: false, path: extIc.path }
            } else {
              return { is_image: false, path: this.file_icons[8].path }
            }
          }
        }
      } else {
        return { is_image: false, path: this.file_icons[6].path }
      }
    },
    deleteSltDoct (i) {
      this.selected_docs.splice(i, 1)
    },
    onUpload () {
      if (!this.selected_docs || !this.selected_docs.length) {
        this.err_file = this.$t('circle_feature.lbl_select_file')
        return
      }
      this.onSubmitFiles(this.selected_docs)
      this.selected_docs = []
      this.modalUpload(false)
    },
    async onSubmitFiles (docs) {
      // let self = this
      // this.uploading = true
      // let params = {
      //   circle_id: this.$route.params.id
      // }
      // const formData = new FormData()
      // for (var key in params) {
      //   formData.append(key, params[key])
      // }
      // docs.forEach((file, i) => {
      //   formData.append('data[' + i + '][name]', file.name)
      //   formData.append('data[' + i + '][file]', file)
      //   formData.append('data[' + i + '][type]', 1)
      // })

      // await self.$rf.getRequest('DoctorRequest').addCircleAttachments(formData).then((r) => {
      //   self.getCircleAttachments()
      //   self.modalUpload(false)
      //   self.selected_docs = []
      //   self.$toast.open({
      //     message: 'Tải lên hoàn tất',
      //     type: 'success'
      //   })
      //   return r
      // }).finally(() => {
      //   self.uploading = false
      // })
      uploadCircleFile.circleUploadHanlder(
        this.$route.params.id,
        this.folder?.id || 0,
        docs,
        1
      )
    },
    async onSubmitLink (options) {
      let self = this
      let params = {
        circle_id: this.$route.params.id,
        name: this.form.name,
        url: this.form.link,
        type: 2
      }
      if (this.$route.params.folder) {
        params.folder_id = this.$route.params.folder
      }
      let r = await this.$rf
        .getRequest('DoctorRequest')
        .createCircleAttachment(params)
        .then(r => {
          self.getCircleAttachments()
          self.modalLink(false)
          this.form.link = ''
          this.form.name = ''
          self.$toast.open({
            message: this.$t('circle_feature.lbl_uploaded_msg'),
            type: 'success'
          })
          return r.data
        })
      return r
    },

    async onSubmitAddFolder () {
      const params = {
        name: this.formFolder.name
      }
      if (this.folder?.id) {
        params.parent_id = this.folder?.id
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .addCircleFolder(this.$route.params.id, params)
        .then(r => {
          this.modalUpFolder(false)
          this.prepare()

          this.$toast.open({
            message: this.$t('circle_feature.lbl_folder_created_msg'),
            type: 'success'
          })
          return r
        })
    },

    async deleteCircleAttachment (id) {
      let self = this
      let r = confirm(this.$t('circle_feature.lbl_confirm_del_msg'))
      if (!r) return
      await this.$rf
        .getRequest('DoctorRequest')
        .deleteCircleAttachment(id)
        .then(() => {
          self.$toast.open({
            message: this.$t('circle_feature.lbl_deleted_msg'),
            type: 'success'
          })
          self.getCircleAttachments()
        })
    },

    async updateCircleFolder () {
      const params = {
        name: this.formFolder.name
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .updateCircleFolder(
          this.$route.params.id,
          this.item_select.folder.id,
          params
        )
        .then(r => {
          this.modalEditFolder(false)
          console.log(this.item_select)
          this.prepare()
          this.$toast.open({
            message: this.$t('circle_feature.lbl_complete_msg'),
            type: 'success'
          })
          return r
        })
    },

    async updateCircleAttachment () {
      const params = {
        name: this.form.name,
        url: this.form.link
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .updateCircleAttachment(this.item_select.file.id, params)
        .then(r => {
          this.getCircleAttachments()
          this.modalEdit(false)
          this.$toast.open({
            message: this.$t('circle_feature.lbl_complete_msg'),
            type: 'success'
          })
          return r
        })
    },

    modalEdit (show, item) {
      this.item_select = item
      this.form = {
        name: item?.file?.name || '',
        link: item?.file?.url || ''
      }
      if (!show) {
        this.$refs.Close.click()
        this.form.link = ''
        this.form.name = ''
      }

      window.$('#modalEdit').modal(show ? 'show' : 'hide')
    },

    modalEditFolder (show, item) {
      this.item_select = item
      this.formFolder = {
        name: item?.folder?.name || '',
        parent_id: item?.folder?.parent_id || ''
      }
      window.$('#modalEditFolder').modal(show ? 'show' : 'hide')
    },

    openDocAttach (doc) {
      if (doc.isFile === 0) {
        this.goToFolder(doc.folder.id)
      } else {
        if (Number(doc.file.type) === FILE_TYPE.pacs) {
          if (doc.file?.pac?.status === 2) {
            this.openPac(doc.file.pac.accession)
          }
        } else if (Number(doc.file.type) === FILE_TYPE.link) {
          window.open(doc.file.url)
        } else {
          if (doc.file.url) {
            window.open(doc.file.url)
          } else if (doc.file.file_name) {
            this.openFile(doc.file.file_name)
          }
        }
      }
    },
    stopPrevent () {
      window.event.stopPropagation()
    },
    getBread (folder, refresh = false) {
      if (folder) {
        if (refresh) this.bread = []
        this.bread.unshift(folder)
        if (folder.parent) {
          this.getBread(folder.parent)
        }
      }
    },

    onUploadPac (file) {
      if (!file) return
      uploadCircleFile.circleUploadHanlder(
        this.$route.params.id,
        this.folder?.id || 0,
        [file],
        3
      )
      setTimeout(() => {
        this.openModalUploadPacs()
      }, 300)
    },
    async openPac (accession) {
      let self = this
      let params = {
        accession: accession
      }
      await self.$rf
        .getRequest('DoctorRequest')
        .getUrlPac(params)
        .then(r => {
          if (r.data) {
            window.open(r.data)
          }
        })
    },
    async openFile (name) {
      const self = this
      const params = {
        fileName: name
      }
      const header = {
        'x-api-key': '4be5160e89e681cede9a80ae6db6af7c'
      }
      await self.$rf
        .getRequest('AuthRequest')
        .getLinkDownloadAwsRc(params, header, false)
        .then(r => {
          if (r?.data?.data) window.open(r.data.data)
        })
        .catch(e => {
          self.$toast.open({
            message: this.$t('circle_feature.lbl_err_down_msg'),
            type: 'warning'
            // all other options
          })
          console.error(e)
        })
    },
    dateLabel (date) {
      if (date === window.moment().format('YYYY-MM-DD')) {
        return this.$t('circle_feature.lbl_today')
      } else {
        return window.moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
      }
    },
    DDMMYYYYSlash (d) {
      if (!d) return
      return window
        .moment(d)
        .utc()
        .format('DD/MM/YYYY HH:mm:ss')
    },
    loadMore () {
      this.getCircleAttachments()
    },
    getPacStatus (stt) {
      return this.pac_statuses.find(s => s.id === stt) || this.statuses[0]
    },
    handleFilter (value) {
      console.log({ value })
    },
    handleOpenDocsMeet () {
      this.$router.push({ name: 'CircleDocumentsMeetFolder' })
    },
    handleShowMeetFolder () {},
    handleChangePagination (data) {
      this.pagination = { ...this.pagination, ...data }

      this.getCircleAttachments(data)
    },
    getCreateBy (item) {
      return item.isFile
        ? item.file?.user?.name || ''
        : item.folder?.user?.name || ''
    },
    getDocType (item) {
      if (item.isFile === 0) return this.$t('lbl_folder')

      if (Number(item.file.type) === FILE_TYPE.link) return 'Link'
      else if (Number(item.file.type) === FILE_TYPE.pacs) return 'PACS File'
      else return this.$t('lbl_files')
    },
    checkRole (item) {
      if (this.circle?.created_by === this.user_id) return true

      if (item.isFile) {
        return item.file?.user?.id === this.user_id
      } else {
        return item.folder?.user?.id === this.user_id
      }
    }
  }
}
</script>
<style scoped>
.circle-docs {
  height: calc(100vh - 90px);
  overflow: auto;
}

.item-drop {
  border-radius: 16px;
}

.item-doc {
  display: flex;
  border-bottom: 1px solid #ebeaed;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}

.item-doc-info {
  height: 76px;
  overflow: hidden;
}

.item-doc-thumb {
  padding: 50px 0px 50px 0px;
}

.item-doc-thumb-img {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 24px;
  width: 24px;
  background-size: contain;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
}

.i-item {
  border: 1px solid black;
}

.upload-btn2 {
  padding: 18px 0px 18px 0px;
}

.upload-btn {
  width: 100%;
  border: 1px dashed #20419b;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  border-radius: 9px;
  cursor: pointer;
}

.u-button {
  border-style: dashed;
  width: 100%;
  border: 2px dashed #edf2f7;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  border-radius: 9px;
  cursor: pointer;
}

.input-search {
  border: 1px solid #edf2f7;
  border-radius: 10px;
}

.selected-file-icon {
  width: 24px;
  height: 24px;
  background-size: contain;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
}

.item-doc-info-text {
  width: calc(100% - 35px);
  padding-left: 15px;
}

.w-265px {
  width: 100%;
  max-width: 265px;
}

.txt-greyscale-600 {
  color: #718096;
}

.border-custom {
  border: 1px solid #dfdfdf;
  border-radius: 16px;
}

.border-bottom {
  border-bottom: 1px solid #ebeaed;
}
</style>